export const analysisData={
    '1week':{
        "total_earning": "3,358",
        "last_year_earning": "7,653",
        "hike": 3,
        "presentation": 145,
        "development": 123,
        "research": 76,
        "earning_hike": 8,
        "sales": "7,469",
        "sales_hike": 10,
        "finance": "3,420",
        "development_price": "7,325",
        "business_price": "6,353",
        "investment_price": "25,252",
        "design": "25,622",
        "trend_goods": "83",
        "shopping_views": "13,452",
        "store_dynamics": "184"
      },
      '1month':{
        "total_earning": "5,372",
        "last_year_earning": "14,678",
        "hike": 2,
        "presentation": 342,
        "development": 254,
        "research": 143,
        "earning_hike": 7,
        "sales": "20,342",
        "sales_hike": 6,
        "finance": "10,457",
        "development_price": "13,634",
        "business_price": "8,945",
        "investment_price": "30,045",
        "design": "56,864",
        "trend_goods": "143",
        "shopping_views": "45,657",
        "store_dynamics": "247"
      },
      "3months":{
        "total_earning": "12,875",
        "last_year_earning": "21,505",
        "hike": 2,
        "presentation": 862,
        "development": 753,
        "research": 553,
        "earning_hike": 10,
        "sales": "43,123",
        "sales_hike": 12,
        "finance": "23,657",
        "development_price": "31,657",
        "business_price": "21,987",
        "investment_price": "76,644",
        "design": "32,982",
        "trend_goods": "204",
        "shopping_views": "65,540",
        "store_dynamics": "324"
      },
      "1year":{
        "total_earning": "54,384",
        "last_year_earning": "92,342",
        "hike": 5,
        "presentation": 7294,
        "development": 6322,
        "research": 1474,
        "earning_hike": 15,
        "sales": "1,45,252",
        "sales_hike": 18,
        "finance": "10,98,313",
        "development_price": "65,725",
        "business_price": "80,738",
        "investment_price": "2,76,780",
        "design": "1,90,083",
        "trend_goods": "3352",
        "shopping_views": "45,25,623",
        "store_dynamics": "5226"
      },"all":{
        "total_earning": "90,34,22",
        "last_year_earning": "34,52,352",
        "hike": 7,
        "presentation": 9264,
        "development": 10342,
        "research": 15234,
        "earning_hike": 20,
        "sales": "8,25,235",
        "sales_hike": 15,
        "finance": "45,23,523",
        "development_price": "1,45,252",
        "business_price": "2,63,623",
        "investment_price": "20,76,780",
        "design": "5,90,525",
        "trend_goods": "5234",
        "shopping_views": "1,75,25,641",
        "store_dynamics": "9358"
      }
    }